import Bruinbot from "../assets/Bruinbot.png";
import HoneyComb from "../assets/HoneyComb.png";
import engmeme2 from '../assets/engmeme2.png';

export const ProjectList = [
  {
    name: "Bruinbot",
    slug: "Bruinbot",
    image: Bruinbot,
    skills: "MERN, AWS, Langchain, HuggingFace, Digital Ocean, Docker",
    github: "https://github.com/ucla-physicalsciences/bruin-bot",
    website: "https://aichat.physics.ucla.edu/home",
  },
  {
    name: "HoneyComb",
    slug: "Honeycomb",
    image: HoneyComb,
    skills: "JavaScript, CSS, HTML, React, MongoDB, Express, Node.js",
    github: "https://github.com/SimplyArsh/HoneyComb",
    website: "https://www.youtube.com/watch?v=5KghRL7N9WA&t=2s&ab_channel=HoneyComb",
  },
  {
    name: "🚧 Work in Progress 🚧",
    slug: "WIP",
    image: engmeme2,
    skills: "Currently under construction... bring your hard hat! 🏗️",
    github: "",
    website: "",
  },
];
